import { RouterProvider } from 'react-router-dom';
import { Toaster } from 'sonner';
import router from './routes';
import ThemeCustomization from './themes';
import ScrollTop from './components/ScrollTop';

export default function App() {
  return (
    <ThemeCustomization>
      <ScrollTop>
        <>
          <RouterProvider router={router} />
          <Toaster closeButton richColors position="top-right" />
        </>
      </ScrollTop>
    </ThemeCustomization>
  );
}
